// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/oopsyraidsy/data/06-ew/dungeon/another_mount_rokkon.ts

import NetRegexes from '../../../../../resources/netregexes';
import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';
import { playerDamageFields } from '../../../oopsy_common';

// TODO: does Shishu Onmitsugashira Issen 8674 cleave?
// TODO: does Splitting Cry 8442 cleave?
// TODO: taking both Vermilion Aura 8436 and Stygian Aura 8437
// TODO: taking two Unnatural Force 8440 stacks
// TODO: standing in outside of Shishio arena
// TODO: better track who didn't take Shishio towers
// TODO: does Gorai Torching Torment cleave?
// TODO: Humble Hammer share damage
// TODO: who missed Gorai towers or was not hit by protean
// TODO: does Lateral Slice cleave
// TODO: 85FD whose adds were too close

export type Data = OopsyData;

const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.AnotherMountRokkonSavage,
  damageWarn: {
    // Trash 1
    'AMRS Shishu Raiko Disciples of Levin': '8668', // centered circle
    'AMRS Shishu Raiko Master of Levin': '8667', // very large donut
    'AMRS Shishu Furutsubaki Bloody Carress': '8669', // front conal
    'AMRS Shishu Fuko Scythe Tail': '866C', // centered circle
    'AMRS Red Shishu Penghou Tornado': '866D', // targeted circle
    'AMRS Shishu Yuki Right Swipe': '8688', // 180 right cleave
    'AMRS Shishu Yuki Left Swipe': '8689', // 180 left cleave

    // Shishio
    'AMRS Shishio Rokujo Revel': '8425', // Smokeater line
    'AMRS Shishio Raiun Leaping Levin 1': '8426', // Raiun 1x Smokeater small cloud circles
    'AMRS Shishio Raiun Leaping Levin 2': '8427', // Raiun 1x Smokeater medium cloud circles
    'AMRS Shishio Raiun Leaping Levin 3': '8428', // Raiun 1x Smokeater large cloud circles
    'AMRS Shishio Lightning Bolt': '842A', // initial Cloud to Cloud circles
    'AMRS Shishio Cloud to Cloud 1': '842B', // 1x Smokeater small lines
    'AMRS Shishio Cloud to Cloud 2': '824C', // 2x Smokeater medium lines
    'AMRS Shishio Cloud to Cloud 3': '824D', // 3x Smokeater large lines
    'AMRS Shishio Noble Pursuit 1': '842E', // initial charge line
    'AMRS Shishio Noble Pursuit 2': '842F', // followup charge line
    'AMRS Shishio Levinburst': '8430', // line damage during Noble Pursuit
    'AMRS Shishio Devilish Thrall Right Swipe': '8432', // 180 right cleave from adds
    'AMRS Shishio Devilish Thrall Left Swipe': '8433', // 180 left cleave from adds
    'AMRS Shishio Haunting Thrall Reisho': '8434', // untelegraphed white explosions from Thralls
    'AMRS Shishio Thunder Vortex': '8439', // donut
    'AMRS Shishio Eye of the Thunder Vortex 1': '843A', // first "out" circle
    'AMRS Shishio Eye of the Thunder Vortex 2': '843B', // second "in" donut
    'AMRS Shishio Vortex of the Thunder Eye 1': '843C', // first "in" donut
    'AMRS Shishio Vortex of the Thunder Eye 2': '843D', // second "out" circle
    'AMRS Shishio Slither': '8443', // back conal

    // Trash 2
    'AMRS Shishu Yamabiko': '868A', // sprite line aoe
    'AMRS Shishu Kotengu Blade of the Tengu': '8671', // Leftward/Rightward/Backward Blows
    'AMRS Shishu Onmitsugashira Juji Shuriken': '8676', // untelegraphed front line
    'AMRS Shishu Onmitsugashira Juji Shuriken Huton': '867E', // untelegraphed fast front line on all players

    // Gorai
    'AMRS Gorai Fire Spread Purple': '853C', // line damage after purple Brazen Ballad
    'AMRS Gorai Fire Spread Blue': '853D', // line damage after blue Brazen Ballad
    'AMRS Gorai Falling Rock Purple': '853F', // expanded rock damage after purple Brazen Ballad
    'AMRS Gorai Falling Rock Blue': '8540', // donutified rock damage after purple Brazen Ballad
    'AMRS Gorai Ball of Levin Shock Small': '8549', // small circle from Ball of Levin hit by Humble Hammer
    'AMRS Gorai Ball of Levin Shock Big': '854A', // large circle from Ball of Levin
    'AMRS Gorai Cloud to Ground 1': '854D', // initial cloud exaflare
    'AMRS Gorai Cloud to Ground 2': '854E', // ongoing cloud exaflare
    'AMRS Gorai Impure Purgation Second': '8553', // follow-up protean'

    // Moko
    'AMRS Moko Triple Kasumi-Giri 1': '85E4', // back red first
    'AMRS Moko Triple Kasumi-Giri 2': '85E5', // left red first
    'AMRS Moko Triple Kasumi-Giri 3': '85E6', // front red first
    'AMRS Moko Triple Kasumi-Giri 4': '85E7', // right red first
    'AMRS Moko Triple Kasumi-Giri 5': '85E8', // back red followup
    'AMRS Moko Triple Kasumi-Giri 6': '85E9', // left red followup
    'AMRS Moko Triple Kasumi-Giri 7': '85EA', // front red followup
    'AMRS Moko Triple Kasumi-Giri 8': '85EB', // right red followup
    'AMRS Moko Triple Kasumi-Giri 9': '85EE', // back blue first
    'AMRS Moko Triple Kasumi-Giri 10': '85EF', // left blue first
    'AMRS Moko Triple Kasumi-Giri 11': '85F0', // front blue first
    'AMRS Moko Triple Kasumi-Giri 12': '85F1', // right blue first
    'AMRS Moko Triple Kasumi-Giri 13': '85F2', // back blue followup
    'AMRS Moko Triple Kasumi-Giri 14': '85F3', // left blue followup
    'AMRS Moko Triple Kasumi-Giri 15': '85F4', // front blue followup
    'AMRS Moko Triple Kasumi-Giri 16': '85F5', // right blue followup
    'AMRS Moko Unbound Spirit': '85EC', // red "out" Triple Kasumi-Giri
    'AMRS Moko Azure Coil': '85ED', // blue "in" Triple Kasumi-Giri

    'AMRS Moko Scarlet Auspice': '8600', // "get out" before Boundless Scarlet
    'AMRS Moko Boundless Scarlet': '8601', // initial red lines before they grow
    'AMRS Moko Explosion': '8602', // growing red lines
    'AMRS Moko Azure Auspice': '8603', // "get under" donut before Boundless Azure
    'AMRS Moko Boundless Azure': '8604', // initial blue lines before they bounce
    'AMRS Moko Upwell 1': '8605', // blue line first bounce
    'AMRS Moko Upwell 2': '8606', // blue line ongoing bounces

    'AMRS Moko Fleeting Iai-Giri 1': '85F6', // back purple
    'AMRS Moko Fleeting Iai-Giri 2': '85F7', // left purple
    'AMRS Moko Fleeting Iai-Giri 3': '85F8', // right purple

    'AMRS Moko Shadow Kasumi-Giri 1': '85F9', // back purple first
    'AMRS Moko Shadow Kasumi-giri 2': '86CC', // left purple followup
    'AMRS Moko Shadow Kasumi-giri 3': '86CD', // front purple followup
    'AMRS Moko Shadow Kasumi-giri 4': '86CE', // right purple followup

    'AMRS Moko Oni\'s Claw Clearout 1': '8C22', // hit 1 of large circles
    'AMRS Moko Oni\'s Claw Clearout 2': '8C28', // hit 2 of large circles
    'AMRS Moko Oni\'s Claw Clearout 3': '860B', // hit 3 of large circles

    'AMRS Moko Ashigaru Kyuhei Iron Rain 1': '85FE', // initial medium circle damage from red Ashigaru Kyuheis
    'AMRS Moko Ashigaru Kyuhei Iron Rain 2': '87A9', // followup medium circle damage from red Ashigaru Kyuheis
    'AMRS Moko Ashigaru Kyuhei Iron Storm 1': '85FF', // initial big circle damage from blue Ashigaru Kyuhei
    'AMRS Moko Ashigaru Kyuhei Iron Storm 2': '87AA', // followup big circle damage from blue Ashigaru Kyuhei
  },
  damageFail: {
    'AMRS Shishio Unmitigated Explosion': '8438', // not taking towers
  },
  gainsEffectWarn: {
    // BF9 = 9999s duration, BFA = 15s duration
    'AMRS Gorai Burns': 'BF9', // standing in outside square of Gorai
  },
  shareWarn: {
    'AMRS Shishu Raiko Barreling Smash': '8665', // line charge
    'AMRS Gorai Pointed Purgation': '8548', // protean tether during towers
    'AMRS Gorai Impure Purgation': '8552', // initial protean for double hit protean
  },
  shareFail: {
    'AMRS Shishio Unnatural Ailment': '843F', // spread during Unnatural Wail
    'AMRS Gorai Great Ball of Fire': '853A', // spread damage from Live Candle debuff
    'AMRS Gorai Worldy Pursuit': '8550', // cross jumps
    'AMRS Moko Vengeful Flame': '8608', // spreads during Fleeting Iai-giri
    'AMRS Moko Accursed Edge': '8607', // bind on players from Far Edge / Near Edge
  },
  soloFail: {
    'AMRS Shishio Unnatural Force': '8440', // pair stack during Unnatural Wail
    'AMRS Gorai Greater Ball of Fire': '8539', // pair stack from Live Brazier debuff
    'AMRS Gorai Flintlock': '854C', // tank block line share
    'AMRS Moko Vengeful Pyre': '8609', // pair stack during Fleeting Iai-giri
  },
  triggers: [
    {
      id: 'AMRS Shishu Kotengu Gaze of the Tengu',
      type: 'Ability',
      netRegex: NetRegexes.ability({ id: '8673', ...playerDamageFields }),
      condition: (data, matches) => data.DamageFromMatches(matches) > 0,
      mistake: (_data, matches) => {
        return {
          type: 'fail',
          blame: matches.target,
          reportId: matches.targetId,
          text: matches.ability,
        };
      },
    },
  ],
};

export default triggerSet;
